/* eslint-disable */
/* tslint:disable */
/*
 * -------------------------------------------------------------------
 * ## THIS FILE WAS GENERATED via our custom react-query-generator  ##
 * ##                                                               ##
 * ## DO NOT MODIFY                                                 ##
 * -------------------------------------------------------------------
 *
 * Tanstack Query Version : `4`
 *
 * Implementation for `patPublicHcdTlcImmediate` hook
 * Endpoint: `/pat-public/hcd/tlc/immediate`
 */

import {
	useQueryClient,
	useQuery,
	useInfiniteQuery,
} from "@tanstack/react-query";

import omitBy from "lodash/omitBy";
import pick from "lodash/pick";

const queryParamsList = [
	"page",
	"limit",
	"searchTerm",
	"searchTerms",
	"sort",
	"dir",
	"speciality.id",
	"speciality.code",
	"speciality.shortName",
	"speciality.statusDate",
	"speciality.status",
	"speciality.isParamedical",
	"speciality.isDirectAccess",
	"speciality.isPractitioner",
	"speciality.target",
	"speciality.algoliaSynchronizedDate",
	"speciality.externalId",
	"speciality.weight",
	"speciality.availabilityMaxWeekPeriod",
	"speciality.synonyms",
	"speciality.isAmcTlcCompatible",
	"speciality.isFavorite",
	"speciality.observatoryId",
	"speciality.nomenclatureId",
	"speciality.usageRanking",
	"speciality.customers",
	"speciality.name",
	"speciality.keywords",
	"speciality.creationDate",
	"speciality.updateDate",
	"speciality.createdBy.userId",
	"speciality.createdBy.label",
	"speciality.lastModifiedBy.userId",
	"speciality.lastModifiedBy.label",
	"specialityIds",
	"specialitiesSynonyms",
	"expertisesSynonyms",
	"expertise.id",
	"expertise.code",
	"expertise.shortName",
	"expertise.statusDate",
	"expertise.status",
	"expertise.algoliaSynchronizedDate",
	"expertise.type",
	"expertise.synonyms",
	"expertise.consultationReasonDuration",
	"expertise.consultationReasonType",
	"expertise.resourceCapacity",
	"expertise.resourceConsultationReasonIds",
	"expertise.name",
	"expertise.keywords",
	"expertise.creationDate",
	"expertise.updateDate",
	"expertise.createdBy.userId",
	"expertise.createdBy.label",
	"expertise.lastModifiedBy.userId",
	"expertise.lastModifiedBy.label",
	"latitude",
	"longitude",
	"clientDocavenue",
	"distanceMax",
	"availabilityFilter.type",
	"availabilityFilter.value",
	"consultationModeFilter",
	"extraFeeFilter",
	"newPatientFilter",
	"languageFilters",
	"locality",
	"regionCode",
	"departmentCode",
	"fullLocality.id",
	"fullLocality.name",
	"fullLocality.shortName",
	"fullLocality.code",
	"fullLocality.type",
	"fullLocality.location.x",
	"fullLocality.location.y",
	"fullLocality.departmentCode",
	"fullLocality.departmentName",
	"fullLocality.departmentShortName",
	"fullLocality.regionCode",
	"fullLocality.regionName",
	"fullLocality.regionShortName",
	"fullLocality.source",
	"fullLocality.postCode",
	"fullLocality.postCodes",
	"fullLocality.score",
	"fullLocality.population",
	"fullLocality.algoliaSynchronizedDate",
	"practitionerIds",
	"visibleOnline",
	"type",
	"computeDistance",
	"patientLimitationFilter",
	"includeDemo",
	"getAllVaccinationPlaces",
	"withProOnlyReason",
	"thirdPartyFilter",
	"customerTagFilter.customerTag",
	"customerTagFilter.allowEmpty",
	"searchOptions",
];

export function makeQueryKey(params, isPaginated) {
	const queryParams = params
		? omitBy(pick(params, queryParamsList), (o) => o === "" || o === null)
		: null;

	return isPaginated
		? [
				"@@api-patient",
				":paginated",
				"pat-public",
				"hcd",
				"tlc",
				"immediate",
				queryParams,
			]
		: ["@@api-patient", "pat-public", "hcd", "tlc", "immediate", queryParams];
}

export function useInvalidateQuery(isPaginated) {
	const queryClient = useQueryClient();
	return function invalidateQuery(params) {
		return queryClient.invalidateQueries({
			queryKey: makeQueryKey(params, isPaginated).filter(Boolean),
		});
	};
}

export function useGet(params, options) {
	return useQuery({
		...options,
		queryKey: makeQueryKey(params),
	});
}

export function prefetch(queryClient, params, options) {
	return queryClient.prefetchQuery({
		...options,
		queryKey: makeQueryKey(params),
	});
}

export function useGetInfinite(params, options) {
	return useInfiniteQuery({
		...options,
		queryKey: makeQueryKey(params, true),
	});
}
